import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Table, TableLoader } from "dyl-components";

import orderActions from 'actions/order';

import Subrows from "./Subrows";
import { useParams } from "react-router-dom";
import OrderColumns from "./OrderColumns";

const Row = ({ order }) => {
    const dispatch = useDispatch();
    const [collapsed, setCollapsed] = useState(true);
    const { account_id } = useParams();

    const { isReading: isReadingInvoices } = useSelector(state => ({
        ...(state.order.invoiceSummary[order.order_id] || {
            isReading: false
        })
    }));

    const { isReading: isReadingCancellations } = useSelector(state => ({
        ...(state.order.cancellations[order.order_id] || {
            isReading: false
        })
    }));

    const onToggle = () => {
        setCollapsed(!collapsed);
        if (collapsed) {
            refreshVersions();
        }
    };

    const refreshVersions = async () => {
        dispatch(orderActions.readOrderInvoices(order.order_id, { account_id }));
        dispatch(orderActions.readCancellations(order.order_id, { account_id }));
    };

    return (
        <Table.CollapsibleRow
            onToggle={onToggle}
            collapsed={collapsed}
            toggleDisabled={!Boolean(order.latest_invoice) && !Boolean(order.has_canceled)}
            subrowContent={
                (isReadingInvoices || isReadingCancellations) ? (
                    <TableLoader colspan={10} isLoading />
                ) : (
                    <Subrows order_id={order.order_id} />
                )
            }
        >
            <OrderColumns order={order} />
        </Table.CollapsibleRow>
    );
}

export default Row;
